import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import { getAllProvincias, getLocalidades } from "../../../api/georef/calls.js"
import InputMask from 'react-input-mask';
import axios from "axios";

import auth from '../../../auth/';
import { Input, Label, FormFeedback } from 'reactstrap';
import CanalSelect from "./CanalSelect.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import SelectSimple from "../../../components/SelectSimple/SelectSimple.js"

import CreateEmpresas from "../../clientes/Empresas/Create.js"

class Edit extends Component {
    IMPACTA_PAIS_OTRO_VALUE = "Otro";
    IMPACTA_PAIS_ARGENTINA_VALUE = "Argentina";

    constructor(props) {
        super(props);
        this.state = {
            numero: "",
            prefijo: "",
            codigo: "",
            empresa_id: null,
            canal_id: null,
            departamento_id: null,
            usaVale: false,
            vale: null,
            prefijoabreviatura:"",

            impacta_pais: "",
            impacta_pais_otro: "",
            impacta_provincia: "",
            impacta_ciudad: "",
            // En caso de que se hayan cargado datos cuando Georef estaba caido
            impacta_provincia_alternative: {},
            impacta_ciudad_alternative: {},

            dataProvincias: [],
            dataCiudades: [],
            cacheDataTodasCiudades: [], // son más de 4000 localidades en Argentina, se cachean por eficiencia.

            errorApiGeoref: false,
        };
    }

    cargarDatosGeoref() {
        this.setState({
            errorApiGeoref: false,
        }, () => {
            const todasLasProvincias = "";

            Promise.all([
                getAllProvincias(),
                getLocalidades(todasLasProvincias)
            ])
            .then(([responseProvincias, responseCiudades]) => {
                this.setState({
                    dataProvincias: responseProvincias.provincias,
                    dataCiudades: responseCiudades.localidades,
                    cacheDataTodasCiudades: responseCiudades.localidades,
                });
            })
            .catch((error) => {
                this.setState({
                    errorApiGeoref: true,
                })
            });
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if ( this.state.dataProvincias.length === 0 && this.state.cacheDataTodasCiudades.length === 0 ) {
            // Para que no quede ciclando infinitamente hay que chequear con los estados previos
            if ( this.state.dataProvincias !== prevState.dataProvincias || this.state.cacheDataTodasCiudades !== prevState.cacheDataTodasCiudades) {
                this.cargarDatosGeoref();
            }
        }
    }

    componentDidMount(){
        this.cargarDatosGeoref()
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects = (data) => {
        const paisIsBlank = !data.impacta_pais || data.impacta_pais.length === 0;
        const provinciaIsBlank = !data.impacta_provincia || data.impacta_provincia.length === 0;
        const ciudadIsBlank = !data.impacta_ciudad || data.impacta_ciudad.length === 0;
        const isPaisOtro =  provinciaIsBlank || ciudadIsBlank;
        let impacta_pais = "";
        let impacta_pais_otro = "";

        if (paisIsBlank) {
            // Caso en que se está editando una solicitud que no tenía localizacion donde impacta el proyecto
            impacta_pais = "";
        } else if (isPaisOtro) {
            // impacta_pais_otro no se guarda en la base de datos, se infiere de la siguiente manera
            impacta_pais = this.IMPACTA_PAIS_OTRO_VALUE;
            impacta_pais_otro = data.impacta_pais;
        } else {
            impacta_pais = data.impacta_pais;
        }

        // En caso de que se cargó una provincia y ciudad mientras el sistema de Georef estaba caído
        // sucede que puede haber una discrepancia entre el nombre de la provincia y ciudad comparado con los de Georef
        // (Nota) ver la parte de render() para ver como se incorporan a los datos
        let impacta_provincia_alternative = {};
        let impacta_ciudad_alternative = {};
        let dataCiudadesEnProvincia = this.state.cacheDataTodasCiudades;

        if (!provinciaIsBlank && !ciudadIsBlank) {
            if (!this.state.dataProvincias.find(provincia => provincia.nombre == data.impacta_provincia)) {
                impacta_provincia_alternative = { nombre: data.impacta_provincia };

                impacta_ciudad_alternative = {
                    nombre: data.impacta_ciudad,
                    provincia_nombre: data.impacta_provincia,
                }
            }

            if (!this.state.dataCiudades.find(ciudad => ciudad.nombre == data.impacta_ciudad)) {
                impacta_ciudad_alternative = {
                    nombre: data.impacta_ciudad,
                    provincia_nombre: data.impacta_provincia,
                }
            }

            dataCiudadesEnProvincia = this.state.cacheDataTodasCiudades.filter(ciudad => ciudad.provincia_nombre == data.impacta_provincia)
        }

        this.setState({
            codigo: data.codigo,
            numero: data.codigo.split('-')[1],
            prefijo: data.codigo.split('-')[0],
            empresa_id: data.empresa_id,
            canal_id: data.canal_id,
            departamento_id: data.departamentointerno_id,
            departamentopadre_id: data.departamentointernopadre_id,
            usaVale: data.usaVale,
            vale: data.vale,

            impacta_pais: impacta_pais,
            impacta_pais_otro: impacta_pais_otro,
            impacta_provincia: data.impacta_provincia,
            impacta_ciudad: data.impacta_ciudad,
            impacta_provincia_alternative: impacta_provincia_alternative,
            impacta_ciudad_alternative: impacta_ciudad_alternative,

            dataCiudades: dataCiudadesEnProvincia,
        });
    }

    resetState() {
        this.setState({
            numero: "",
            prefijo: "",
            codigo: "",
            empresa_id: null,
            canal_id: null,
            departamento_id: null,
            departamentopadre_id: null,
            usaVale: false,
            vale: null,
            prefijoabreviatura:"",

            impacta_pais: "",
            impacta_pais_otro: "",
            impacta_provincia: "",
            impacta_ciudad: "",
            impacta_provincia_alternative: {},
            impacta_ciudad_alternative: {},

            dataCiudades: this.state.cacheDataTodasCiudades,
        });
    }

    handleDepartamentoPadreChange = (data) => {
        if (this.state.departamentopadre_id !== data.pk) {
            this.setState({
                departamentopadre_id: data.pk,
                departamento_id: null,
            })
        }
    }

    onChangeDepartamento(e) {
        var depto = e.pk;
        var newprefijo = e.abreviatura;
        var url = api.proyectos.solicitudes.getnumero + "?prefijo=" + newprefijo;
        axios.get(url, auth.header())
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        numero: response.data.numero,
                    });
                }
            });
        if(this.state.usaVale){
            this.setState({departamento_id: depto, prefijoabreviatura: newprefijo})
        }else{
            this.setState({ prefijo: newprefijo, departamento_id: depto, prefijoabreviatura: newprefijo });
        }
    }

    onChangeCodigo(prefijo, numero, departamento_id) {
        this.setState({
            'codigo': prefijo + "-" + numero,
            'numero': numero,
            'prefijo': prefijo,
            'departamento_id': departamento_id
        })
    }

    handleImpactaPaisChange = (pais) => {
        if (pais && this.state.impacta_pais != pais.value) {
            this.setState({
                impacta_pais: pais.value,
                impacta_pais_otro: "",
                impacta_provincia: "",
                impacta_ciudad: "",
                dataCiudades: this.state.cacheDataTodasCiudades,
            })
        } else if (pais == null) {
            this.setState({
                impacta_pais: "",
                impacta_pais_otro: "",
                impacta_provincia: "",
                impacta_ciudad: "",
                dataCiudades: this.state.cacheDataTodasCiudades,
            })
        }
    }

    handleImpactaPaisOtro = (e) => {
        this.setState({
            impacta_pais_otro: e.target.value,
        })
    }

    handleImpactaProvinciaChange = (provincia) => {
        if (provincia && this.state.impacta_provincia != provincia.value) {
            const dataCiudadesEnProvincia = this.state.cacheDataTodasCiudades.filter(ciudad => ciudad.provincia_nombre == provincia.value)
            const existeCiudad = dataCiudadesEnProvincia.find(ciudad => ciudad.nombre == this.state.impacta_ciudad);

            this.setState({
                impacta_provincia: provincia.value,
                dataCiudades: dataCiudadesEnProvincia,
                impacta_ciudad: existeCiudad ? this.state.impacta_ciudad : "",
            })
        } else if (provincia == null) { // En caso de que se limpió el select
            this.setState({
                impacta_provincia: "",
                impacta_ciudad: "",
                dataCiudades: this.state.cacheDataTodasCiudades,
            })
        }
    }

    handleImpactaCiudadChange = (ciudad) => {
        if (ciudad && this.state.impacta_ciudad != ciudad.value) {
            this.setState({
                impacta_ciudad: ciudad.value,
            }, () => {
                if (this.state.impacta_provincia != ciudad.provincia_nombre) {
                    // Caso en que se cambió de ciudad pero no pertenecen a la misma provincia
                    // (solo ocurre si se selecciona una ciudad y no habia provincia seleccionada anteriormente)
                    const dataCiudadesEnProvincia = this.state.cacheDataTodasCiudades.filter(dataCiudad => dataCiudad.provincia_nombre == ciudad.provincia_nombre)

                    this.setState({
                        impacta_provincia: ciudad.provincia_nombre,
                        dataCiudades: dataCiudadesEnProvincia,
                    })
                }
            })
        } else if (ciudad == null) { // En caso de que se limpió el select
            this.setState({
                impacta_ciudad: "",
            })
        }
    }

    render() {
        const {
            impacta_ciudad,
            impacta_pais,
            impacta_pais_otro,
            impacta_provincia,
            impacta_provincia_alternative,
            impacta_ciudad_alternative,
            dataCiudades,
            dataProvincias,
            errorApiGeoref,
        } = this.state;

        const opcionesImpactaPais = [
            { value: this.IMPACTA_PAIS_OTRO_VALUE, label: "Otro" },
            { value: this.IMPACTA_PAIS_ARGENTINA_VALUE, label: "Argentina" },
        ];

        let opcionesImpactaProvincia = dataProvincias.map(provincia => ({
            value: provincia.nombre,
            label: provincia.nombre,
        }));

        // Alternativa cuando se cargó un valor manualmente que no pertenece a la data de Georef
        if (Object.keys(impacta_provincia_alternative).length > 0) {
            opcionesImpactaProvincia.push({
                value: impacta_provincia_alternative.nombre,
                label: impacta_provincia_alternative.nombre,
            });
        }
        opcionesImpactaProvincia = opcionesImpactaProvincia.sort((a, b) => a.label.localeCompare(b.label));

        let opcionesImpactaCiudad = dataCiudades.map(ciudad => ({
            value: ciudad.nombre,
            // En caso de que la ciudad tenga mismo nombre pero distinta provincia se aclara (Solo si no hay una provincia seleccionada).
            label: ciudad.nombre + (impacta_provincia === "" ? ` (${ciudad.provincia_nombre})` : ""),
            provincia_nombre: ciudad.provincia_nombre,
        }));

        // Alternativa cuando se cargó un valor manualmente que no pertenece a la data de Georef
        if (impacta_ciudad_alternative && impacta_provincia === impacta_ciudad_alternative.provincia_nombre) {
            opcionesImpactaCiudad.push({
                value: impacta_ciudad_alternative.nombre,
                label: impacta_ciudad_alternative.nombre,
                provincia_nombre: impacta_provincia,
            });
        }
        opcionesImpactaCiudad = opcionesImpactaCiudad.sort((a, b) => a.label.localeCompare(b.label));

        return (
            <ParadigmaModal
                getUrl={api.proyectos.solicitudes.edit}
                postUrl={api.proyectos.solicitudes.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Solicitud ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Solicitud"}
                buttonTitle={"Editar Solicitud"}
                buttonIcon={"fa fa-pencil fa-lg"}
                className={"ui-modal-dialog ui-modal-lg"}
                saveButton={true}
                closeButton={true}
                notAllowedMessage={"La Solicitud no puede ser editada en esta etapa porque ya fue avanzada."}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >

                <div className="ui-form">
                    <div className="ui-section-grid">
                        <section className="ui-section-block">
                            <p className="ui-section-label">Identificación</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Grupo</Label>
                                    <ParadigmaAsyncSeeker
                                        clearable={false}
                                        onChange={this.handleDepartamentoPadreChange}
                                        fieldName=""
                                        url={api.usuarios.grupos.select}
                                        value={this.state.departamentopadre_id}
                                    />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Subgrupo</Label>
                                    <ParadigmaAsyncSeeker
                                        disabled={!this.state.departamentopadre_id}
                                        clearable={false}
                                        onChange={(e) => this.onChangeDepartamento(e)}
                                        fieldName={"departamentointerno_id"}
                                        url={api.usuarios.subgrupos.select + (this.state.departamentopadre_id
                                            ? "?grupo=" + this.state.departamentopadre_id : "")}
                                        value={this.state.departamento_id}
                                    />
                                </div>
                            </div>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Número</Label>
                                    <InputMask
                                        name=""
                                        className="form-control"
                                        mask="9999"
                                        value={this.state.numero}
                                        onChange={(e) => this.onChangeCodigo(this.state.prefijo, e.target.value, this.state.departamento_id)}
                                        type="text"
                                    />
                                </div>
                                <div className="ui-field">
                                    <Label>Código</Label>
                                    <Input
                                        disabled
                                        style={{ backgroundColor: "#c1c1c1", color: "#4b4b4b"}}
                                        value={this.state.vale ? this.state.prefijo + "-" + this.state.vale : this.state.prefijo + "-" + this.state.numero}
                                    />
                                    <Input
                                        type="hidden"
                                        name="codigo"
                                        value={this.state.vale ? this.state.prefijo + "-" + this.state.vale : this.state.prefijo + "-" + this.state.numero}
                                    />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <p className="ui-section-label">Tipo de solicitud</p>
                                <div className="ui-radio-group">
                                    <input type={"hidden"} name="usaVale" value={this.state.usaVale} />
                                    <Label className={"ui-radio-opt"}>
                                        <input
                                            type={"radio"}
                                            checked={this.state.usaVale == false}
                                            onClick={() => { this.setState({ usaVale: false, prefijo: this.state.prefijoabreviatura, vale: null }) }}
                                        />
                                        <span>Presupuesto</span>
                                    </Label>
                                    <Label className={"ui-radio-opt"}>
                                        <input
                                            type={"radio"}
                                            checked={this.state.usaVale == true}
                                            onClick={() => this.setState({ usaVale: true, prefijo: "V" })}
                                        />
                                        <span>Vale de Innovación</span>
                                    </Label>
                                </div>
                            </div>
                            {this.state.usaVale &&
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <Label>Vale de Innovación</Label>
                                        <Input
                                            type="text"
                                            name="vale"
                                            value={this.state.vale}
                                            onChange={(event) => this.setState({ vale: event.target.value })}
                                        />
                                    </div>
                                </div>
                            }
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Datos principales</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Título</Label>
                                    <Input type="text" name="nombre" />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Forma de Contacto</Label>
                                    <CanalSelect value={this.state.canal_id} onChange={(e) => this.setState({ canal_id: e.pk })} />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Empresa/Organización</Label>
                                    <ParadigmaAsyncSeeker
                                        Create={CreateEmpresas}
                                        fieldName={"empresa_id"}
                                        url={api.clientes.empresas.select}
                                        value={this.state.empresa_id}
                                        onChange={(e) => this.setState({ empresa_id: e.pk })}
                                    />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Localización donde impacta el proyecto</p>
                            {errorApiGeoref &&
                                <FormFeedback className="d-block">{"Hubo un error con el servidor externo de Georef (puede seguir ingresando manualmente los datos)."}</FormFeedback>
                            }
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>País</Label>
                                    <SelectSimple
                                        name={"impacta_pais"}
                                        options={opcionesImpactaPais}
                                        value={opcionesImpactaPais.find(opcion => opcion.value === impacta_pais)}
                                        onChange={this.handleImpactaPaisChange}
                                    />
                                </div>

                                {impacta_pais === this.IMPACTA_PAIS_OTRO_VALUE &&
                                    <div className="ui-field">
                                        <Label>Otro país</Label>
                                        <Input
                                            type="text"
                                            name={"impacta_pais_otro"}
                                            value={impacta_pais_otro}
                                            onChange={this.handleImpactaPaisOtro}
                                            placeholder="Especifique el país..."
                                        />
                                        <FormFeedback className="col-12"></FormFeedback>
                                    </div>
                                }
                            </div>

                            {impacta_pais != "" && impacta_pais !== this.IMPACTA_PAIS_OTRO_VALUE &&
                                <div className="ui-row-2">
                                    <div className="ui-field">
                                        <Label>Provincia</Label>
                                        {!errorApiGeoref &&
                                            <SelectSimple
                                                name={"impacta_provincia"}
                                                options={opcionesImpactaProvincia}
                                                value={opcionesImpactaProvincia.find(opcion => opcion.value === impacta_provincia)}
                                                onChange={this.handleImpactaProvinciaChange}
                                            />
                                        }
                                        {errorApiGeoref &&
                                            <Fragment>
                                                <Input
                                                    type="text"
                                                    name={"impacta_provincia"}
                                                    value={impacta_provincia}
                                                    onChange={e => this.setState({impacta_provincia: e.target.value})}
                                                    placeholder="Especifique la provincia..."
                                                />
                                                <FormFeedback className="col-12"></FormFeedback>
                                            </Fragment>
                                        }
                                    </div>
                                    <div className="ui-field">
                                        <Label>Ciudad</Label>
                                        {!errorApiGeoref &&
                                            <SelectSimple
                                                name={"impacta_ciudad"}
                                                options={opcionesImpactaCiudad}
                                                value={opcionesImpactaCiudad.find(opcion => opcion.value === impacta_ciudad)}
                                                onChange={this.handleImpactaCiudadChange}
                                            />
                                        }
                                        {errorApiGeoref &&
                                            <Fragment>
                                                <Input
                                                    type="text"
                                                    name={"impacta_ciudad"}
                                                    value={impacta_ciudad}
                                                    onChange={e => this.setState({ impacta_ciudad: e.target.value })}
                                                    placeholder="Especifique la ciudad..."
                                                />
                                                <FormFeedback className="col-12"></FormFeedback>
                                            </Fragment>
                                        }
                                    </div>
                                </div>
                            }
                        </section>

                        <section className="ui-section-block ui-section-compact">
                            <p className="ui-section-label">Observaciones</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Observaciones</Label>
                                    <Input type="textarea" name="observaciones" rows={5} />
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento1/Edit.js